import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';

type LockableBankAccountControls = {
  lock_bank_account: FormControl<boolean | null>;
};

export type UnlockBankAccountDialogData = {
  bank_account: FormGroup<LockableBankAccountControls>;
};

@Component({
  selector: 'app-unlock-bank-account-dialog',
  templateUrl: './unlock-bank-account-dialog.component.html',
  styleUrls: ['./unlock-bank-account-dialog.component.scss'],
  imports: [PayeePopupComponent],
})
export class UnlockBankAccountDialogComponent {
  private dialogRef =
    inject<MatDialogRef<UnlockBankAccountDialogComponent>>(MatDialogRef);

  data = inject<UnlockBankAccountDialogData>(MAT_DIALOG_DATA);

  readonly submit = () => {
    const b = this.data.bank_account;
    b.controls.lock_bank_account.patchValue(false);
    b.disable();
    this.dialogRef.close();
  };

  readonly cancel = () => {
    this.dialogRef.close();
  };
}
